const SSO_REDIRECT_AT_KEY = "ssoRedirectAt";
const SSO_REDIRECT_COOLDOWN_MS = 10000;

export const SSO_LOGIN_URL = process.env.REACT_APP_SSO_LOGIN_URL || "https://sso.kesp.cl/sso/login.htm";

export const redirectToSSOLogin = () => {
  const last = Number(sessionStorage.getItem(SSO_REDIRECT_AT_KEY) || 0);
  if (Date.now() - last < SSO_REDIRECT_COOLDOWN_MS) return false;
  sessionStorage.setItem(SSO_REDIRECT_AT_KEY, String(Date.now()));
  window.location.assign(SSO_LOGIN_URL);
  return true;
};